import styled from '@emotion/styled'
import { V2L2SmallModalRoot } from "../V2L2ModalRoot"
import { V2L2ModalTitlebar, V2L1ModalDismissButton } from "../V2ModalTitlebar"
import { V2L1LoadingIndicator } from '../../Indicator/V2L1LoadingIndicator'
import L2ControlGrid from '../../../form/l2/L2ControlGrid'
import L2ControlGridLayout from '../../../form/l2/L2ControlGridLayout'
import { shortGuid } from '@fusion-advantage/formlib'
import { L1ClipboardCopyButton, useClipboardCopy } from '../../../interface/L1ClipboardCopyButton'

const Loading = styled.div(({theme}) => ({
	boxSizing: 'border-box',
	minHeight: '7rem',
	backgroundColor: theme.colors.logBg,
	color: theme.colors.white,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
}))

const ModalContent = styled(Loading)(({theme}) => ({
	...theme.fonts.mono,
	justifyContent: 'flex-start',
	fontSize: `${14/16}rem`,
	letterSpacing: `${1/32}em`,
	lineHeight: `${18/12}em`,
	padding: '1rem',
	'svg': {
		fontSize: '1rem',
	},
}))

interface V2L3DevTokenModalProps {
	loading: boolean
	token: string|null
	onDismissClick?: () => void
}

export const V2L3DevTokenModal = ({loading, token, onDismissClick}: V2L3DevTokenModalProps) => {
	const copy1 = useClipboardCopy(token, () => onDismissClick ? onDismissClick() : null)
	const copy2 = useClipboardCopy(`peh set-token ${token}`, () => onDismissClick ? onDismissClick() : null)
	const copy3 = useClipboardCopy(`-H "Authorization: Bearer ${token}"`, () => onDismissClick ? onDismissClick() : null)
	const short = token ? shortGuid(token) : ''
	return (
		<V2L2SmallModalRoot>
			<V2L2ModalTitlebar
				title="API Token"
				buttons={<V2L1ModalDismissButton onClick={onDismissClick} />}
			/>
			{loading ? (
				<Loading>
					<V2L1LoadingIndicator big />
				</Loading>
			) : (
				<ModalContent>
					<L2ControlGrid layout={L2ControlGridLayout.FlowRow} columnCount={2}>
						<L1ClipboardCopyButton showSuccess={copy1.showSuccess} onClick={copy1.handleClick} />
						{token}
						<L1ClipboardCopyButton showSuccess={copy2.showSuccess} onClick={copy2.handleClick} />
						peh set-token {short}...
						<L1ClipboardCopyButton showSuccess={copy3.showSuccess} onClick={copy3.handleClick} />
						-H "Authorization: Bearer {short}..."
					</L2ControlGrid>
				</ModalContent>
			)}
		</V2L2SmallModalRoot>
	)
}
